import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import LinearProgress from '~/components/LinearProgress';
import Button from '~/components/Button';

import Request from '~/providers/Request';

import ChannelData from './ChannelData';

function ChatHistory({ id, user_id }) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [chats, setChats] = useState([]);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const rowsPerPage = 1;

  async function fetchChats() {
    setLoading(true);
    Request.get(
      `/admin/chats/${id}/history_chats/`,
      { page: page, per_page: rowsPerPage, userId: user_id },
      { normalizeJSON: false }
    )
      .then((response) => {
        setLoading(false);
        setChats(response.data.concat(chats));
        setPage(page + 1);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  useEffect(() => {
    async function hasManyChats() {
      setLoading(true);
      Request.get(
        `/admin/chats/${id}/has_history_chats/`,
        { userId: user_id },
        { normalizeJSON: false }
      )
        .then((response) => {
          setLoading(false);
          setTotalPages(response.count);
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
        });
    }
    if (id && user_id) {
      hasManyChats();
    }
  }, [id, user_id]);

  return (
    <>
      {page <= totalPages && (
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button
            style={{ marginLeft: 10 }}
            disabled={false}
            size="small"
            color="second"
            onClick={() => {
              fetchChats();
            }}
          >
            {t('chats.extras.load_more')} <ArrowUpwardIcon />
          </Button>
        </div>
      )}

      <Divider />

      {chats.map((row) => {
        return (
          <div key={row.id}>
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                marginTop: '10px',
              }}
            >
              <Typography
                style={{
                  color: '#ffffff',
                  backgroundColor: '#AC92EA',
                  borderRadius: '40px 20px',
                  padding: '5px',
                }}
                variant="h6"
              >
                {t('chats.extras.start_chat')}
              </Typography>

              <Typography variant="body1" style={{ marginLeft: '10px' }}>
                {moment(row.created_at).format('DD/MM/YYYY HH:mm:ss')}{' '}
                {t('chats.attributes.subject')}: {row?.subject}
              </Typography>
            </div>

            <LinearProgress loading={loading} />

            <ChannelData messages={row?.messages} user_id={row.user_to_id} />

            <LinearProgress loading={loading} />

            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                marginBotton: '10px',
              }}
            >
              <Typography
                style={{
                  color: '#ffffff',
                  backgroundColor: '#AC92EA',
                  borderRadius: '50px 20px',
                  padding: '5px',
                }}
                variant="h6"
              >
                {t('chats.extras.end_chat')}
              </Typography>
            </div>

            <Divider />
          </div>
        );
      })}
    </>
  );
}

export default ChatHistory;
